export default {
  CallPlanDetail: {
    Roles: ['admin'],
    EventName: 'CallPlanDetail',
    DisplayName: 'Routing Plan',
    EventWeight: 100,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      ineligibleTargets: {
        IsStrValue: true,
        EventFieldName: 'IneligibleTargets',
        Field: {
          DisplayName: 'Ineligible Targets',
          FieldName: 'ineligibleTargets',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      eligibleOrderedTargets: {
        IsStrValue: true,
        EventFieldName: 'EligibleTargets',
        Field: {
          DisplayName: 'Eligible Targets',
          FieldName: 'eligibleOrderedTargets',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  CustomScoringCheck: {
    Roles: ['admin'],
    EventName: 'CustomScoringCheck',
    DisplayName: 'Custom Scoring Check',
    EventWeight: 100,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestUrl: {
        IsStrValue: true,
        EventFieldName: 'requestUrl',
        Field: {
          DisplayName: 'Request URL',
          FieldName: 'requestUrl',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestHeaders: {
        IsStrValue: true,
        EventFieldName: 'requestHeaders',
        Field: {
          DisplayName: 'Request Headers',
          FieldName: 'requestHeaders',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      }
    }
  },
  JornayaTCPACheck: {
    Roles: ['admin'],
    EventName: 'JornayaTCPACheck',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'Result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'cost',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      }
    }
  },
  PingFailure: {
    Roles: ['admin'],
    EventName: 'PingFailure',
    DisplayName: 'Ring Tree Target Failure',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      error: {
        IsStrValue: true,
        EventFieldName: 'error',
        Field: {
          DisplayName: 'Error',
          FieldName: 'error',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      isFromCache: {
        EventFieldName: 'isFromCache',
        ShowOnlyWhenTrue: true,
        Field: {
          DisplayName: 'From Cache',
          FieldName: 'isFromCache',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'bool',
          IsSearchable: false
        }
      },
    }
  },
  PingTreePingingSummary: {
    Roles: ['admin'],
    EventName: 'PingTreePingingSummary',
    DisplayName: 'Ring Tree Pinging Summary',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        FieldWeight: 0,
        Field: {
          DisplayName: 'Conversion Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      pingTreeName: {
        IsValue: false,
        EventFieldName: 'pingTreeName',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree',
          FieldName: 'pingTreeName',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'string'
        }
      },
      pingTreeId: {
        IsValue: false,
        EventFieldName: 'pingTreeId',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Ring Tree Id',
          FieldName: 'pingTreeId',
          FieldType: 'string',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'string'
        }
      },
      winningRingTreeTarget: {
        IsStrValue: true,
        EventFieldName: 'winningRingTreeTarget',
        FieldWeight: 3,
        Field: {
          DisplayName: 'Winning',
          FieldName: 'winningRingTreeTarget',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      acceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'acceptedRingTreeTargets',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Accepted',
          FieldName: 'acceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      notAcceptedRingTreeTargets: {
        IsStrValue: true,
        EventFieldName: 'notAcceptedRingTreeTargets',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Not Accepted',
          FieldName: 'notAcceptedRingTreeTargets',
          IsHidden: true,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      }
    }
  },
  PingRAWResult: {
    Roles: ['admin'],
    EventName: 'PingRAWResult',
    DisplayName: 'Ring Tree Target Raw Result',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      httpStatusCode: {
        IsValue: true,
        EventFieldName: 'httpStatusCode',
        Field: {
          DisplayName: 'Http Status Code',
          FieldName: 'httpStatusCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      url: {
        IsStrValue: true,
        EventFieldName: 'url',
        Field: {
          DisplayName: 'URL',
          FieldName: 'url',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      method: {
        IsStrValue: true,
        EventFieldName: 'method',
        Field: {
          DisplayName: 'Method',
          FieldName: 'method',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestStatus: {
        IsStrValue: true,
        EventFieldName: 'requestStatus',
        Field: {
          DisplayName: 'Request Status',
          FieldName: 'requestStatus',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      isFromCache: {
        EventFieldName: 'isFromCache',
        ShowOnlyWhenTrue: true,
        Field: {
          DisplayName: 'From Cache',
          FieldName: 'isFromCache',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'bool',
          IsSearchable: false
        }
      },
    }
  },
  PingSuccess: {
    Roles: ['admin'],
    EventName: 'PingSuccess',
    DisplayName: 'Ring Tree Target Success',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      bid: {
        IsValue: true,
        EventFieldName: 'bid',
        Field: {
          DisplayName: 'Bid',
          FieldName: 'bid',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      staticRevenueAmount: {
        IsValue: true,
        EventFieldName: 'staticRevenueAmount',
        Field: {
          DisplayName: 'Static Revenue Amount',
          FieldName: 'staticRevenueAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      dynamicCallLength: {
        IsValue: true,
        EventFieldName: 'dynamicCallLength',
        Field: {
          DisplayName: 'Dynamic Call Length',
          FieldName: 'dynamicCallLength',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      },
      staticConversionCallLengthValue: {
        IsValue: true,
        EventFieldName: 'staticConversionCallLengthValue',
        Field: {
          DisplayName: 'Static Call Length',
          FieldName: 'staticConversionCallLengthValue',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      },
      ptnumber: {
        IsStrValue: true,
        EventFieldName: 'ptnumber',
        Field: {
          DisplayName: 'Number',
          FieldName: 'ptnumber',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      },
      accepted: {
        IsStrValue: true,
        EventFieldName: 'accepted',
        Field: {
          DisplayName: 'Accepted',
          FieldName: 'accepted',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      minimumRevenueAmount: {
        IsValue: true,
        EventFieldName: 'minimumRevenueAmount',
        Field: {
          DisplayName: 'Min Revenue Amount',
          FieldName: 'minimumRevenueAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          IsSearchable: false
        }
      },
      pingTimeout: {
        IsValue: true,
        EventFieldName: 'pingTimeout',
        Field: {
          DisplayName: 'Ping Timeout',
          FieldName: 'pingTimeout',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      maxDynamicDuration: {
        IsValue: true,
        EventFieldName: 'maxDynamicDuration',
        Field: {
          DisplayName: 'Max Dynamic Duration',
          FieldName: 'maxDynamicDuration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'seconds',
          IsSearchable: false
        }
      },
      isFromCache: {
        EventFieldName: 'isFromCache',
        ShowOnlyWhenTrue: true,
        Field: {
          DisplayName: 'From Cache',
          FieldName: 'isFromCache',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'bool',
          IsSearchable: false
        }
      },
    }
  },
  RPCCalculationSummary: {
    Roles: ['admin'],
    EventName: 'RPCCalculationSummary',
    DisplayName: 'RPC Calculation Summary',
    EventWeight: 150,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        FieldWeight: 0,
        Field: {
          DisplayName: 'Calculation Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      jsonId: {
        IsValue: false,
        EventFieldName: 'jsonId',
        ShouldFlaten: false,
        FieldWeight: 20,
        Field: {
          DisplayName: 'Json ID',
          FieldName: 'jsonId',
          FieldType: 'string',
          IsHidden: true,
          Roles: ['admin'],
          Scubbers: 'string'
        }
      },
      duplicate: {
        IsStrValue: true,
        EventFieldName: 'duplicate',
        FieldWeight: 3,
        Field: {
          DisplayName: 'Duplicate',
          FieldName: 'duplicate',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      errored: {
        IsStrValue: true,
        EventFieldName: 'errored',
        FieldWeight: 2,
        Field: {
          DisplayName: 'Errored',
          FieldName: 'errored',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      calculated: {
        IsStrValue: true,
        EventFieldName: 'calculated',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Calculated',
          FieldName: 'rpcCalculated',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'list',
          IsSearchable: false
        }
      },
      actualCount: {
        IsValue: true,
        EventFieldName: 'actualCount',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Total Targets',
          FieldName: 'actualCount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      shown: {
        IsValue: true,
        EventFieldName: 'shown',
        FieldWeight: 1,
        Field: {
          DisplayName: 'Shown Targets',
          FieldName: 'shown',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      }
    }
  },
  RTBBidTrace: {
    Roles: ['admin'],
    EventName: 'RTBBidTrace',
    DisplayName: 'Bid Trace',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Date',
          FieldName: 'dtStamp',
          FieldType: 'date',
          Scubbers: 'date'
        }
      },
      id: {
        IsValue: false,
        EventFieldName: 'id',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'ID',
          FieldName: 'id',
          FieldType: 'string'
        }
      },
    }
  },
  RTBWinningBid: {
    Roles: ['admin'],
    EventName: 'RTBWinningBid',
    DisplayName: 'RTB Winning Bid',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      callerId: {
        IsStrValue: true,
        EventFieldName: 'callerId',
        Field: {
          DisplayName: 'Caller ID',
          FieldName: 'callerId',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      callAccepted: {
        IsValue: true,
        EventFieldName: 'callAccepted',
        Field: {
          DisplayName: 'Call Accepted',
          FieldName: 'callAccepted',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'bool'
        }
      },
      bidAmount: {
        IsValue: true,
        EventFieldName: 'bidAmount',
        Field: {
          DisplayName: 'Bid Amount',
          FieldName: 'bidAmount',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'currency',
          Scubbers: 'positive',
          IsSearchable: false
        }
      }
    }
  },
  SecondPingSuccess: {
    Roles: ['admin'],
    EventName: 'SecondPingSuccess',
    DisplayName: 'Confirmation Request Success',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      ptnumber: {
        IsStrValue: true,
        EventFieldName: 'ptnumber',
        Field: {
          DisplayName: 'Number',
          FieldName: 'ptnumber',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      }
    }
  },
  SecondPingFailure: {
    Roles: ['admin'],
    EventName: 'SecondPingFailure',
    DisplayName: 'Confirmation Request Failure',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      error: {
        IsStrValue: true,
        EventFieldName: 'error',
        Field: {
          DisplayName: 'Error',
          FieldName: 'error',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'text',
          IsSearchable: false
        }
      }
    }
  },
  SecondPingRAWResult: {
    Roles: ['admin'],
    EventName: 'SecondPingRAWResult',
    DisplayName: 'Confirmation Request Raw Result',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      httpStatusCode: {
        IsValue: true,
        EventFieldName: 'httpStatusCode',
        Field: {
          DisplayName: 'Http Status Code',
          FieldName: 'httpStatusCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          IsSearchable: false
        }
      },
      url: {
        IsStrValue: true,
        EventFieldName: 'url',
        Field: {
          DisplayName: 'URL',
          FieldName: 'url',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      method: {
        IsStrValue: true,
        EventFieldName: 'method',
        Field: {
          DisplayName: 'Method',
          FieldName: 'method',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      requestStatus: {
        IsStrValue: true,
        EventFieldName: 'requestStatus',
        Field: {
          DisplayName: 'Request Status',
          FieldName: 'requestStatus',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      }
    }
  },
  TrustedFormCheck: {
    Roles: ['admin'],
    EventName: 'TrustedFormCheck',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      duration: {
        IsValue: true,
        EventFieldName: 'duration',
        Field: {
          DisplayName: 'Duration',
          FieldName: 'duration',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'milliseconds',
          IsSearchable: false
        }
      },
      result: {
        IsStrValue: true,
        EventFieldName: 'result',
        Field: {
          DisplayName: 'Result',
          FieldName: 'result',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      errorMessage: {
        IsStrValue: true,
        EventFieldName: 'errorMessage',
        Field: {
          DisplayName: 'Error Message',
          FieldName: 'errorMessage',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      responseBody: {
        IsStrValue: true,
        EventFieldName: 'responseBody',
        Field: {
          DisplayName: 'Response Body',
          FieldName: 'responseBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestBody: {
        IsStrValue: true,
        EventFieldName: 'requestBody',
        Field: {
          DisplayName: 'Request Body',
          FieldName: 'requestBody',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      },
      requestUrl: {
        IsStrValue: true,
        EventFieldName: 'requestUrl',
        Field: {
          DisplayName: 'Request URL',
          FieldName: 'requestUrl',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          IsSearchable: false
        }
      },
      responseCode: {
        IsValue: true,
        EventFieldName: 'responseCode',
        Field: {
          DisplayName: 'Response Code',
          FieldName: 'responseCode',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'number',
          Scubbers: 'positive',
          IsSearchable: false
        }
      },
      integrationMethod: {
        IsStrValue: true,
        EventFieldName: 'integrationMethod',
        Field: {
          DisplayName: 'Integration Method',
          FieldName: 'integrationMethod',
          IsHidden: false,
          Roles: ['admin'],
          FieldType: 'string',
          Scubbers: 'hideEmpty',
          IsSearchable: false
        }
      }
    }
  },
  ZeroRTBBid: {
    Roles: ['admin'],
    EventName: 'ZeroRTBBid',
    DisplayName: 'Zero RTB Bid',
    EventWeight: 500,
    Fields: {
      dtStamp: {
        IsValue: false,
        EventFieldName: 'dtStamp',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'Timestamp',
          FieldName: 'dtStamp',
          FieldType: 'date',
          IsHidden: false,
          Roles: ['admin'],
          Scubbers: 'date'
        }
      },
      id: {
        IsValue: false,
        EventFieldName: 'id',
        ShouldFlaten: false,
        Field: {
          DisplayName: 'ID',
          FieldName: 'id',
          FieldType: 'string'
        }
      },
    }
  }
};